import React from "react";
import Homepage from "./pages/Homepage";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import Chatbot from "./components/Chatbot";
import Careers from "./pages/Careers";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import JobApplication from "./pages/JobApplication";
import Seo from "./pages/Seo";
import ITHomePage from "./pages/ITHomePage";
import DigitalMarketing from "./pages/DigitalMarketing";
import WebDevelopment from "./services/it/WebDevelopment";
import MobileAppDevelopment from "./services/it/MobileAppDevelopment";
import CloudSolutions from "./services/it/CloudSolutions";
import Cybersecurity from "./services/it/Cybersecurity";
import ITInfrastructure from "./services/it/ITInfrastructure";
import DatabaseManagement from "./services/it/DatabaseManagement";
import DevOpsServices from "./services/it/DevOpsServices";
import AiMlServices from "./services/it/AiMlServices";
import SEOServices from "./services/digitalMarketing/SEOServices";
import SocialMediaMarketingService from "./services/digitalMarketing/SocialMediaMarketingService";
import ContentCreationService from "./services/digitalMarketing/ContentCreationService";
import PPCAdvertisingService from "./services/digitalMarketing/PPCAdvertisingService";
import AnalyticsReportingService from "./services/digitalMarketing/AnalyticsReportingService";
import EmailMarketingService from "./services/digitalMarketing/EmailMarketingService";
import ConversionOptimizationService from "./services/digitalMarketing/ConversionOptimizationService";
import InfluencerMarketingService from "./services/digitalMarketing/InfluencerMarketingService";
import HealthcareIndustry from "./industries/HealthcareIndustry";
import EducationIndustry from "./industries/EducationIndustry";
import ManufacturingIndustry from "./industries/ManufacturingIndustry";
import FMCGIndustry from "./industries/FMCGIndustry";
import FoodBeveragesIndustry from "./industries/FoodBeveragesIndustry";
import HospitalityIndustry from "./industries/HospitalityIndustry";
import ToursTravelsIndustry from "./industries/Toursandtravels";
import RealEstateIndustry from "./industries/Realestate";
import { SpeedInsights } from "@vercel/speed-insights/react"

const App = () => {

  return (
    <>
      <BrowserRouter>
      <SpeedInsights />
        <Routes>
          <Route path="/*" element={<Homepage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/seo" element={<Seo />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />

          <Route path="/apply/:id" element={<JobApplication />} />

          <Route path="/it" element={<ITHomePage />} />
          <Route path="/marketing" element={<DigitalMarketing />} />

          <Route
            path="/services/digital-marketing/social-media"
            element={<SocialMediaMarketingService />}
          />

          <Route
            path="/services/digital-marketing/content"
            element={<ContentCreationService />}
          />

          <Route
            path="/services/digital-marketing/ppc"
            element={<PPCAdvertisingService />}
          />
          <Route
            path="/services/digital-marketing/email"
            element={<EmailMarketingService />}
          />

          <Route
            path="/services/digital-marketing/analytics"
            element={<AnalyticsReportingService />}
          />
          <Route
            path="/services/digital-marketing/conversion-optimization"
            element={<ConversionOptimizationService />}
          />
          <Route
            path="/services/digital-marketing/influencer-marketing"
            element={<InfluencerMarketingService />}
          />
          

          <Route
            path="/services/it/web-development"
            element={<WebDevelopment />}
          />
          <Route
            path="/services/it/mobile-app-development"
            element={<MobileAppDevelopment />}
          />
          <Route
            path="/services/it/cloud-solutions"
            element={<CloudSolutions />}
          />
          <Route
            path="/services/it/cybersecurity"
            element={<Cybersecurity />}
          />
          <Route
            path="/services/it/infrastructure"
            element={<ITInfrastructure />}
          />
          <Route
            path="/services/it/database"
            element={<DatabaseManagement />}
          />
          <Route path="/services/it/devops" element={<DevOpsServices />} />
          <Route path="/services/it/ai-ml" element={<AiMlServices />} />

          <Route
            path="/services/digital-marketing/seo"
            element={<SEOServices />}
          />

          {/* Alternative Routes for Industries */}
          
          <Route
            path="industries/food-beverages"
            element={<FoodBeveragesIndustry />}
          />
          <Route
            path="industries/hospitality"
            element={<HospitalityIndustry />}
          />
          <Route
            path="industries/tours-travels"
            element={<ToursTravelsIndustry />}
          />
          <Route
            path="industries/real-estate"
            element={<RealEstateIndustry />}
          />



          <Route
            path="industries/healthcare"
            element={<HealthcareIndustry />}
          />
          <Route
            path="industries/education"
            element={<EducationIndustry />}
          />
          <Route
            path="industries/manufacturing"
            element={<ManufacturingIndustry />}
          />
          <Route path="industries/fmcg" element={<FMCGIndustry />} />
        </Routes>
        
      </BrowserRouter>
      <Chatbot />
    </>
  );
};

export default App;
